import { render, staticRenderFns } from "./LocationLink.vue?vue&type=template&id=6de4d521&"
import script from "./LocationLink.vue?vue&type=script&lang=js&"
export * from "./LocationLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports